<template>
  <div>
    <div class="card mb-0 shadow" v-if="!editar_encaminhamento">
      <div class="card-body">
        <div class="tab-content">
          <div class="animate__animated animate__fadeIn">
            <div class="row">
              <div class="col-12">
                <h4 class="font-weight-bold">Encaminhamentos</h4>
              </div>
              <div class="col-md-12">
                <div
                  v-if="!novo_encaminhamento"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="novo_encaminhamento = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div>
                          <div class="input-group mb-3">
                            <b-input
                              :placeholder="$t('Type to search')"
                              class="form-control search-input"
                              type="text"
                              v-model="search"
                              v-on:change="getEncaminhamentos"
                              aria-describedby="input-search"
                            />
                            <div class="input-group-append" role="button">
                              <span class="input-group-text" id="input-search"
                                ><i class="fas fa-search search-icon"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <load mode="table" v-if="loadingEncaminhamentos" />
                    <div class="col-12" v-else>
                      <b-table
                        :fields="[
                          {
                            key: 'protocolo',
                            label: $t('Detalhes'),
                          },
                          {
                            key: 'cadastrado',
                            label: $t('Data'),
                          },
                          {
                            key: 'status_nome',
                            label: $t('Status'),
                          },
                          {
                            key: 'actions',
                            label: '',
                            class: 'text-right',
                            thStyle: { width: '95px', minWidth: '95px' },
                          },
                        ]"
                        :items="EncaminhamentosList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="md"
                        table-class="mb-3"
                      >
                        <template v-slot:cell(protocolo)="data">
                          Usuário(s):<br />
                          <ul>
                            <li
                              v-for="pessoa in data.item.usuarios"
                              :key="pessoa.id"
                            >
                              <b>{{ pessoa.nome_completo }}</b>
                            </li>
                          </ul>
                          Protocolo: <b>{{ data.item.protocolo }}</b>
                          <br />
                          Tipo: <b>{{ data.item.tipo.descricao }}</b>
                          <br />
                          Origem:
                          <b v-if="data.item.unidade">{{
                            data.item.unidade.nome
                          }}</b>
                          <br />
                          Técnico
                          <b>{{ data.item.tecnico.nome }}</b>

                          <span v-if="data.item.unidade_destino">
                            <br />
                            Unidade de Destino:
                            <b>{{ data.item.unidade_destino.nome }}</b>
                          </span>
                          <span
                            v-if="data.item.unidade_externa"
                            class="text-muted text-xs"
                          >
                            - Unidade Externa
                          </span>
                          <span v-if="data.item.tecnico_destino">
                            <br />
                            Técnico de Destinatário:
                            <b>{{ data.item.tecnico_destino.nome }}</b>
                          </span>
                        </template>
                        <template v-slot:cell(cadastrado)="data">
                          {{ data.item.cadastrado }}
                        </template>
                        <template v-slot:cell(status_nome)="data">
                          <span
                            class="small"
                            v-html="data.item.status_nome"
                          ></span>
                        </template>
                        <template v-slot:cell()="data">
                          <button
                            @click="
                              encaminhamentoSelected = data.item.id;
                              editar_encaminhamento = true;
                            "
                            class="px-2 mb-0 btn btn-sm btn-success"
                          >
                            <i class="mdi mdi-square-edit-outline" />
                          </button>
                        </template>
                        <template v-slot:empty="scope">
                          <div class="text-center my-5">
                            <img
                              :alt="$t('No results')"
                              class="mb-5"
                              src="/img/icons/robot.svg"
                              style="max-height: 165px"
                            />
                            <h3 class="bold">{{ $t("No records found") }}</h3>
                          </div>
                        </template>
                      </b-table>

                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getEncaminhamentos"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }} {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoEncaminhamento
                  v-else
                  :familia="0"
                  :morph="{
                    id: item.id,
                    type: 'ScfvGrupo',
                  }"
                  :usuariosvinculados="pessoas"
                  @voltar="novo_encaminhamento = false"
                  @reload="
                    getEncaminhamentos();
                    novo_encaminhamento = false;
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditarEncaminhamento
      v-else
      :morph="true"
      :morph-encaminhamento-id="encaminhamentoSelected"
      morph_type="ScfvGrupo"
      @voltar="editar_encaminhamento = false"
    />
  </div>
</template>
<script>
import NovoEncaminhamento from "../../../../../../Encaminhamento/Resources/assets/js/Add";
import EditarEncaminhamento from "../../../../../../Encaminhamento/Resources/assets/js/Edit";

export default {
  components: { NovoEncaminhamento, EditarEncaminhamento },
  props: ["item"],
  name: "Encaminhamentos",
  metaInfo() {
    return {
      title: this.$i18n.t("Encaminhamentos"),
    };
  },
  data() {
    return {
      encaminhamentoSelected: "",
      editar_encaminhamento: false,
      novo_encaminhamento: false,
      TipoEncaminhamentosList: [],
      EncaminhamentosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loadingEncaminhamentos: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  computed: {
    pessoas() {
      const pessoas = this.item.lista_inscritos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: elem.nome_completo + " <b>" + elem.idade_extenso + "</b>",
      }));

      return map;
    },
  },
  mounted() {
    this.getEncaminhamentos();
  },
  methods: {
    getEncaminhamentos() {
      this.loadingEncaminhamentos = true;
      axios
        .get("api/dashboard/encaminhamentos", {
          params: {
            morph_type: "ScfvGrupo",
            morph_id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.EncaminhamentosList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getEncaminhamentos();
          } else {
            this.loadingEncaminhamentos = false;
          }
        })
        .catch(() => {
          this.loadingEncaminhamentos = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getEncaminhamentos();
      }
    },
    redirectEncaminhamento(id) {
      this.$router.push({
        path: `/dashboard/encaminhamentos/edit/${id}`,
      });
    },
  },
};
</script>

